import React, { createContext, useState, useContext } from 'react';

// コンテキストの作成
const AuthContext = createContext();

const storedIsAuthenticated = sessionStorage.getItem('isAuthenticated') || false;
const storedToken           = sessionStorage.getItem('token') || null;
const storedFacilityCode    = sessionStorage.getItem('facilityCode') || null;
const storedFacilityName    = sessionStorage.getItem('facilityName') || null;
const storedUserId          = sessionStorage.getItem('userId') || null;
const storedUserName        = sessionStorage.getItem('userName') || null;
const storedAuthority       = sessionStorage.getItem('authority') || null;
const storedAuthorityName   = sessionStorage.getItem('authorityName') || null;
const storedTraderCode      = sessionStorage.getItem('traderCode') || null;
const storedTrader          = sessionStorage.getItem('trader') || null;
const storedTargetDate      = sessionStorage.getItem('targetDate') || null;

// プロバイダーコンポーネントの作成
export const AuthProvider = ({ children }) => {
  const [authInfo, setAuthInfo] = useState({
    isAuthenticated : storedIsAuthenticated,
    token           : storedToken,
    facilityCode    : storedFacilityCode,
    facilityName    : storedFacilityName,
    userId          : storedUserId,
    userName        : storedUserName,
    authority       : storedAuthority,
    authorityName   : storedAuthorityName,
    traderCode      : storedTraderCode,
    trader          : storedTrader,
    targetDate      : storedTargetDate
  });

  return (
    <AuthContext.Provider value={{ authInfo, setAuthInfo }}>
      {children}
    </AuthContext.Provider>
  )
}

// カスタムフックの作成
export const useAuth = () => {
  return useContext(AuthContext);
}